<main class="cd-main">
  <!-- HEADER -->
  <div class="cd-header-row">
    <div>
      <h1 class="cd-title">Manage SIS Integration</h1>
      <p class="cd-subtitle">Manage SIS Integration</p>
    </div>
    <div class="header-actions">
      <button
        mat-stroked-button
        class="cd-draft-btn"
        (click)="integrate()"
        aria-label="Save as draft"
      >
        Confirm Integration
      </button>
    </div>
  </div>

  <form [formGroup]="form" aria-label="Career page form">
    <div class="ce-main">
      <!-- BASICS -->
      <mat-card class="ce-card" appearance="outlined">
        <mat-card-content>
          <h2 class="ce-section-title">Basic info</h2>

          <mat-radio-group
            formControlName="connectionType"
            class="ce-radio-group"
            aria-label="API or CSV integration"
          >
            <mat-radio-button value="API" color="primary" class="ce-radio">
              <div>
                <div class="ce-radio-label">API</div>
              </div>
            </mat-radio-button>
            <mat-radio-button value="CSV" color="primary" class="ce-radio">
              <div>
                <div class="ce-radio-label">CSV</div>
              </div>
            </mat-radio-button>
          </mat-radio-group>

          @if (form.get('connectionType')!.value === 'API') {
            <mat-form-field appearance="fill" class="ce-field" subscriptSizing="dynamic">
              <mat-label>BaseUrl</mat-label>
              <input matInput formControlName="baseUrl" aria-label="BaseUrl" />
              <mat-error>BaseUrl is required</mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill" class="ce-field" subscriptSizing="dynamic">
              <mat-label>Client Id</mat-label>
              <input matInput formControlName="clientId" aria-label="clientId" />
              <mat-error>Client Id is required</mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill" class="ce-field" subscriptSizing="dynamic">
              <mat-label>Client Secret</mat-label>
              <input matInput formControlName="clientSecret" aria-label="clientSecret" />
              <mat-error>Client Secret is required</mat-error>
            </mat-form-field>

            <h2 class="ce-section-title">Sync settings</h2>

            <mat-form-field appearance="fill" class="ce-field" subscriptSizing="dynamic">
              <mat-label>Sync Frequency</mat-label>
              <mat-select formControlName="syncFrequency" aria-label="Sync frequency">
                <mat-option value="HOURLY">Hourly</mat-option>
                <mat-option value="DAILY">Daily</mat-option>
                <mat-option value="WEEKLY">Weekly</mat-option>
              </mat-select>
              <mat-error>Sync frequency is required</mat-error>
            </mat-form-field>

            <mat-slide-toggle formControlName="automaticSync" color="primary">
              Enable automatic sync
            </mat-slide-toggle>
          }

          @if (form.get('connectionType')!.value === 'CSV') {
            <h2 class="ce-section-title">Roster Upload</h2>
            <p class="cd-subtitle" style="font-size: 12px; margin-bottom: 8px">
              Upload a OneRoster CSV bundle (.zip) containing your orgs, users, classes, and
              enrollments files to load in schools, staff, students, and enrollments.
            </p>

            <input
              #bannerInput
              type="file"
              accept=".zip"
              style="display: none"
              aria-label="Upload roster CSV bundle"
              (change)="onZipAdded($event)"
            />

            <div
              class="ce-upload-dropzone"
              role="button"
              tabindex="0"
              aria-label="Click to upload roster ZIP"
              (click)="bannerInput.click()"
              (keydown.enter)="bannerInput.click()"
              (keydown.space)="bannerInput.click()"
            >
              <mat-icon class="ce-upload-icon" aria-hidden="true">folder_zip</mat-icon>
              <div class="ce-upload-label">Click to upload roster ZIP</div>
              <div class="ce-upload-hint">
                .zip (contains orgs.csv, users.csv, classes.csv, enrollments.csv)
              </div>
            </div>

            @if (form.get('zipFile')!.value) {
              <p class="cd-subtitle" style="font-size: 12px; margin-top: 8px">
                Selected: {{ form.get('zipFile')!.value?.name }}
              </p>
            }

            @if (form.get('zipFile')!.touched && form.get('zipFile')!.hasError('required')) {
              <p class="ce-error" style="color: #b3261e; font-size: 12px; margin-top: 4px">
                Please upload a roster ZIP file.
              </p>
            }

            @if (form.get('zipFile')!.hasError('invalidType')) {
              <p class="ce-error" style="color: #b3261e; font-size: 12px; margin-top: 4px">
                Only .zip files are supported.
              </p>
            }

            @if (form.get('zipFile')!.hasError('tooLarge')) {
              <p class="ce-error" style="color: #b3261e; font-size: 12px; margin-top: 4px">
                File is too large. Max size is 50MB.
              </p>
            }
          }
        </mat-card-content>
      </mat-card>
    </div>
  </form>
</main>
